export const NEWS_SITE_DOMAINS = [
	'https://news.jtbc.co.kr',
	'https://news-app.jtbc.co.kr/',
	'https://mnews.jtbc.co.kr/',
	'https://dev-news.jtbc.co.kr',
	'https://dev-news-app.jtbc.co.kr/',
	'https://dev-mnews.jtbc.co.kr/',
	'https://stg-news.jtbc.co.kr',
	'https://stg-news-app.jtbc.co.kr/',
	'https://stg-mnews.jtbc.co.kr/',
]

export const SENTRY_ALLOWED_PATHS = [
	// '/article',
	// '/board',
	// '/correctionRebuttal',
	// '/election',
	// '/issues',
	'/journalist',
	// '/live',
	'/mypage',
	// '/poll',
	// '/program',
	// '/pub',
	// '/rankNews',
	'/report',
	'/rss',
	// '/search',
	// '/sections',
	'/series',
	'/service',
	// '/shorts',
	// '/topic',
	// '/video',
]
